export default __webpack_public_path__ + "static/inspection1_maxapps-b289d70e013b84168fa99b88620cd304.png";